import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import MainLoader from '../../components/shared/MainLoader';
import Tabs from '../../components/shared/Tabs';
import { defaultTabs } from '../../constants/ExploreDataNav';
import TemplateContext from '../../context/TemplateContext';
import useBoolean from '../../hooks/use-boolean';
import { PagesCont } from '../../interfaces/DataAnalytics/Pages';
import Tab from '../../interfaces/general/Tab';
import DataAnalyticPageBuilderService from '../../services/DataAnalyticPageBuilderService';
import ArcGisComponent from './ArcGis';
import PowerBiReport from './Power-Bi';
import PricingInformation from './PricingInformation';
import IncomeInformation from './IncomeInformation';
import AutomatedValuations from './AutomatedValuations';
import Predictability from './Predictability';

const ViewExploreData = () => {
    const history = useHistory(),
        { t } = useTranslation(['f', 'b']),
        [allPages, setAllPages] = useState<Array<Tab>>([]),
        [templateData] = useState<Array<any>>([]),
        [isPageLoad, setIsPageLoadActions] = useBoolean(),
        location = useLocation();
    let activTab = location.hash ? location.hash.replace('#', '') : '1';

    const tabSelected = (value: any) => {
        history.push({ hash: value });
    };

    const fetchPages = useCallback(async () => {
        try {
            const _pages: PagesCont = await DataAnalyticPageBuilderService.fetchPages();
            const shownPages: Array<Tab> = [];
            _pages.items.forEach((elem) => {
                let tab = defaultTabs.find((tab) => tab.name === elem.name);

                if (tab) {
                    tab.id = elem.id;
                    shownPages.push(tab);
                }
            });
            shownPages.push(
                {
                    id: 1000,
                    icon: '',
                    name: 'dataAnalytics.oxfordEconomics',
                    component: <PowerBiReport />,
                },
                {
                    id: 1001,
                    icon: '',
                    name: 'dataAnalytics.buildingDirectory',
                    component: (
                        <ArcGisComponent
                            url="/building-directory"
                            width="100%"
                            height="100%"
                            title="Building Directory"
                        />
                    ),
                },
                {
                    id: 1002,
                    icon: '',
                    name: 'dataAnalytics.transactionData',
                    component: (
                        <ArcGisComponent
                            url="/transaction-data"
                            width="100%"
                            height="100%"
                            title="Transaction Data"
                        />
                    ),
                },
                {
                    id: 1003,
                    icon: '',
                    name: 'dataAnalytics.pricingInformation',
                    component: <PricingInformation />,
                },
                {
                    id: 1004,
                    icon: '',
                    name: 'dataAnalytics.incomeInformation',
                    component: <IncomeInformation />,
                },
                {
                    id: 1005,
                    icon: '',
                    name: 'dataAnalytics.automatedValuations',
                    component: <AutomatedValuations />,
                },
                {
                    id: 1006,
                    icon: '',
                    name: 'dataAnalytics.predictability',
                    component: <Predictability />,
                }
            );
            setAllPages(shownPages);
            setIsPageLoadActions.setTrue();
        } catch (error: any) {
            toast(t(`b:${error.response.data.errorMessage}`));
        }
    }, [t, setIsPageLoadActions]);

    useEffect(() => {
        fetchPages();
    }, [fetchPages]);

    return (
        <div className="explore-data-page d-flex">
            <div className="explore-data-page__main">
                {isPageLoad ? (
                    <TemplateContext>
                        <Tabs tabs={allPages} onTabSelected={tabSelected} defaultActiveKey={activTab} />
                    </TemplateContext>
                ) : (
                    <MainLoader type="regular" mb="mb-100" />
                )}
            </div>
        </div>
    );
};

export default ViewExploreData;
